import React from 'react';
import PropTypes from 'prop-types';
import { RecordingIcon } from '@bizzabo/icons';
import BZPopover from 'web-common/bizzabo-components/components/BZPopover';
import LoginPopover from '../LoginPopover';
import FeatureToggleUtils from 'FeatureToggleUtils';
import RegisterAndLoginPopper from '../RegisterAndLoginPopper';
import {
    sendCustomClick
} from '../../../../utils/SnowplowUtils';
import {
    buttonTypes
} from '../../../../constants/SnowplowConst';

const Button = ({
    onClick,
    iconElement,
    text='Watch Recording',
    setLoginV2OffsetTop,
}) => {
    const handleLogin = (event) => {
        sendCustomClick(buttonTypes.watchOnDemandButton, text, event.currentTarget);
        setLoginV2OffsetTop?.(event.pageY);
        onClick && onClick();
    };

    return (
        <button className='join-broadcast-btn bz-button font-size-12 custom-color color-1-background color-1-hover-opacity' onClick={handleLogin}>
            {iconElement ? (
                iconElement
            ) : (
                <RecordingIcon
                    className="broadcast-icon"
                    fill="#ffffff"
                    fontSize="20px"
                />
            )}
            <span>{text}</span>
        </button>
    );
};

const WatchRecordingButton = ({
    onClick = () => {},
    showEmailLogin,
    eventUrls,
    isAuthenticated = false,
    iconElement,
    text = 'Watch Recording',
    showRegisterAndLoginModal,
    eventName,
    isWidget,
    setLoginV2OffsetTop,
    analyticData,
}) => {
    const isAgendaLoginFlowEnabled = !FeatureToggleUtils.isFeatureEnabled('oldLogin');

    if (isAgendaLoginFlowEnabled) {
        if ((isWidget && window.self !== window.parent) && !isAuthenticated) {
            return (
                <RegisterAndLoginPopper
                    button={
                        <Button
                            iconElement={iconElement}
                            text={text}
                            setLoginV2OffsetTop={setLoginV2OffsetTop}
                        />
                    }
                    onLoginClick={showEmailLogin}
                    eventUrls={eventUrls}
                    eventName={eventName}
                />
            );
        }

        const handleBtnClick = () => {
            isAuthenticated
                ? onClick()
                : showRegisterAndLoginModal();
        };

        return (<Button onClick={handleBtnClick} iconElement={iconElement} text={text} />);
    }

    return (
        isAuthenticated ? (
            <Button onClick={onClick} iconElement={iconElement} text={text} />
        ) : (
            <BZPopover
                placement="right"
                cls="need-login-popover"
                button={<Button iconElement={iconElement} text={text} />}
                popover={
                    <LoginPopover
                        onLoginClick={showEmailLogin}
                        eventUrls={eventUrls}
                        analyticData={analyticData}
                    />
                }
            />
        )
    );
};

WatchRecordingButton.propTypes = {
    onClick: PropTypes.func,
    isAuthenticated: PropTypes.bool,
    iconElement: PropTypes.element,
    text: PropTypes.string,
    showEmailLogin: PropTypes.func,
    eventUrls: PropTypes.shape({}),
    showRegisterAndLoginModal: PropTypes.func,
    analyticData: PropTypes.shape({})
};

export default WatchRecordingButton;
